import React from 'react';
import { useFormState } from 'react-final-form';
// eslint-disable-next-line import/no-duplicates
import { addSeconds, format } from 'date-fns';
// eslint-disable-next-line import/no-duplicates
import { ru } from 'date-fns/locale';
import { TitleStlyed } from './styles';

export const Time: React.FC<{ duration: number; day?: Date }> = ({
  duration,
  day,
}) => {
  const {
    values: { date },
  } = useFormState();

  const visitDate = new Date(day || date);

  return (
    <>
      <TitleStlyed>Дата и время</TitleStlyed>

      <div>
        <span>
          {format(visitDate, 'd MMMM (', {
            locale: ru,
          })}
        </span>
        <span>
          {visitDate.toLocaleString('ru', {
            weekday: 'long',
          })}
        </span>
        <span>
          {format(visitDate, '), HH:mm', {
            locale: ru,
          })}
        </span>
        {duration ? (
          <span>
            {format(addSeconds(visitDate, duration), ' - HH:mm', {
              locale: ru,
            })}
          </span>
        ) : null}
      </div>
    </>
  );
};
